var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadingWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#a4c0c9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184,67.28A161.92,161.92,0,0,0,147.7,50.49a7.54,7.54,0,0,0-1.27-.41,164.06,164.06,0,0,0-46.29-7.51h-.28a164,164,0,0,0-46.28,7.51,7.76,7.76,0,0,0-1.29.41A162,162,0,0,0,16,67.28a8,8,0,0,0-3.31,9.34L38.29,152a8,8,0,0,0,7.57,5.43H154.14a8,8,0,0,0,7.57-5.43l25.58-75.38A8,8,0,0,0,184,67.28ZM148.4,141.43H51.6L29.94,77.6a145.58,145.58,0,0,1,19.22-9l2.29,13a8,8,0,0,0,7.87,6.61,8.36,8.36,0,0,0,1.4-.12,8,8,0,0,0,6.49-9.27L64.53,63.55A149,149,0,0,1,92,58.93v16.8a8,8,0,1,0,16,0V58.94a148.23,148.23,0,0,1,27.47,4.61l-2.68,15.23a8,8,0,0,0,6.49,9.27,8.36,8.36,0,0,0,1.4.12,8,8,0,0,0,7.87-6.61l2.29-13a145.58,145.58,0,0,1,19.22,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.74,97.61a5,5,0,0,0-9.48,0l-10.1,27.27a5,5,0,0,0,4.74,6.59h20.2a5,5,0,0,0,4.74-6.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadingWeight);
export default __webpack_public_path__ + "static/media/Reading - Weight.e1bd17cc45b7dcff3069b71b67e84543.svg";
export { ForwardRef as ReactComponent };